import { render } from "./index.vue?vue&type=template&id=d106cf04&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=d106cf04&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-d106cf04"

export default script